import api from '@/api/common/group.js'
const state = {
}
const mutations = {
}
const actions = {
	getGroupList({}, params = {}) {
        return api.grouplist(params)
	},
    addgroupFun({},params) {
		return api.addgroup(params)
	},
    groupsort({},params) {
		return api.groupsort(params)
	},
	sectionsort({},params) {
		return api.sectionsort(params)
	},
    groupRemove({},params) {
		return api.groupremove(params)
	}
	
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}